<template>
  <div>
    <div class="logo-containers">
      <van-row type="flex" justify="center">
        <van-col span="4"></van-col>
        <van-col span="8"><img src="../../assets/logo.png" width="100%" alt=""></van-col>
        <van-col span="4"></van-col>
      </van-row>
      <div class="gap"></div>
      <van-row type="flex" justify="center">
        <van-col span="6"></van-col>
        <van-col span="12">欢迎登录移动工单平台</van-col>
        <van-col span="6"></van-col>
      </van-row>
    </div>
    <div class="login-input-containers">
      <van-row type="flex" justify="center">
        <van-col span="2"></van-col>
        <van-col span="20">
          <van-cell-group>
            <van-field
              v-model="userinfo.username"
              required
              label="账号"
              placeholder="请输入用户名"
              :clearable="true"
            />
            <van-field
              v-model="userinfo.password"
              required
              label="密码"
              placeholder="请输入密码"
              :error-message="''"
              type="password"
              :clearable="true"
            />
          </van-cell-group>
        </van-col>
        <van-col span="2"></van-col>
      </van-row>
      <div class="logo-containers">
        <van-row type="flex" justify="center">
          <van-col span="12">
            <van-button color="#004099" class="btns" type="primary" @click="login" block>登录</van-button>
            <van-button color="#004099" class="btns" type="primary" @click="registers">注册</van-button>
          </van-col>
        </van-row>
      </div>
    </div>
    <div class="tip-area">
      提示：如忘记账号和密码，请及时联系客服人员 400-0566-360
    </div>
  </div>
</template>

<script>
import { Col, Row,Field,CellGroup,Button,Icon,Toast,Dialog} from 'vant';
import { mapMutations } from 'vuex';
  export default {
    components : {
      [Row.name]:Row,
      [Toast.name]:Toast,
      [Col.name]:Col,
      [Field.name]:Field,
      [CellGroup.name]:CellGroup,
      [Icon.name]:Icon,
      [Button.name]:Button,
      [Dialog.name]:Dialog
    },
    mounted(){
      // if(!this.$route.query.code || this.$route.query.code == ''){ 
      //     var appid = 'wxf686e8ab7875b150'
      //           //var local = window.location.href  
      //     var local = 'http://yunshikongwebs.vaiwan.com/register'
      //     var url = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid='+appid+'&redirect_uri='+ encodeURIComponent(local)+'?type=logins&response_type=code&scope=snsapi_userinfo&state=123#wechat_redirect' 
      //     window.location.href = url 
      // }
     
    },
    data(){
      return {
        userinfo : {
          username : '',
          password : ''
        }
      }
    },
    methods : {
      ...mapMutations(['saveinfo']),
      async login(){
        // var params = new URLSearchParams();
        // params.append('username', this.userinfo.username);
        // params.append('password', this.userinfo.password);
        var params = {
          username:this.userinfo.username,
          password:this.userinfo.password
        }
        var _this = this;
        const res = await this.$http.post(`/mobile/kf/login`,params).then((data)=> data.data)
        console.log(res)
        if(res.code == 200){
          this.$cookies.set('status', 'ok')
          this.$cookies.set('token', res.token)
          
          this.$http.get(`/getInfo`,{headers: { Authorization: "Bearer " + res.token}}).then(function(res1){
            if(res1.data.code=200){
                _this.saveinfo(res1.data.user)
                console.log(res1.data.user.openId)
                _this.$router.push({
                  path : '/feedback',
                  query:{openid:res1.data.user.openId}
                })
            }
          })
          
        } else{
          Dialog.alert({
              title: '标题',
              message: res.msg,
            }).then(() => {
              // on close
            });
        }
      },
      registers(){
        this.$router.push({
          path : 'register'
        })
      }
    }
  }
</script>

<style scoped>
.logo-containers{
  padding-bottom : 60px;
  text-align : center;
  height : 105px;
  margin-top : 100px;
}
.gap{
  height : 20px;
}
.tip-area{
  text-align : center;
  width : 100%;
  font-size : 12px;
  color : rgb(185, 183, 183);
}
.btns{
    width:48% !important;
    float: left;
    margin-right: 2%;
}
</style>



// WEBPACK FOOTER //
// src/pages/login/index.vue